import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Divider, Input } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "right",
  align: "right",
  maxHeight: "80vh",
  overflowY: "auto",
  paddingRight: "8px", // optional: avoids scrollbar overlap
};

export default function AdditionalQuestion({
  setOpen,
  onFormSubmit,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onFormSubmit: (formData: any) => void;
}) {
  const handleClose = () => setOpen(false);
  const items = [
    "کشت فصل زراعی قبل",
    "کشت دوفصل زراعی قبل",
    "کشت سه فصل زراعی قبل",
    "کشت چهار فصل زراعی قبل",
    "فاصله عرضی کشت بذر",
    "عمق کشت بذر",
    "آبیاری چند روز یکبار انجام میشود",
    "آیا گیاه بدلیل ناهمواری زمین بیش از حد نیاز آب دریافت میکند",
    "آیا گیاه بدلیل ناهمواری مزرعه کمتر از حد نیاز آب دریافت میکند",
    "تاریخ آخرین آبیاری",
    "کود های استفاده شده",
    "تاریخ آخرین کوددهی",
    "میزان آخرین کوددهی",
    "تاریخ آخرین سم پاشی",
    "میزان آخرین سم پاشی",
    "روش انجام آخرین سم پاشی",
    "نوع سم های استفاده شده",
    "میزان فراوانی عارضه در سطح زیر کشت",
    "مدل توزیع جغرافیایی آن در سطح زیر کشت",
    "سن کشت",
    "میزان گستردگی عامل خسارت زا",
    "پراکندگی عامل خسارت زا",
    "تظاهر در ابتدا چگونه بوده و چه تغییراتی داشته است",
    "بیماری ها یا آفات قبلی در این دوره کشت در این مزرعه",
    "بیماریها یا آفات قبلی در این دوره کشت در این منطقه",
  ];
  const [form, setForm] = React.useState<Record<string, string>>({});

  return (
    <div>
      <Modal
        open={true}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="b">
            لطفا با پاسخ به این سوالات به تشخیص بهتر کمک کنید (اختیاری)
          </Typography>
          {items.map((item, index) => (
            <SingleElement
              key={index}
              inputText={item}
              setValue={(value) => {
                setForm((prev) => ({
                  ...prev,
                  [item]: value,
                }));
              }}
            />
          ))}
          <Box sx={{ marginTop: 2 }}>
            <Button
              variant="contained"
              onClick={async () => {
                onFormSubmit(form);
              }}
            >
              ارسال
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

function SingleElement({
  inputText,
  setValue,
}: {
  inputText: string;
  setValue: (text: string) => void;
}) {
  return (
    <Box>
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        {inputText}
      </Typography>
      <Input onChange={(e) => setValue(e.target.value)} />
    </Box>
  );
}
